import { render, staticRenderFns } from "./Kanban.skeleton.vue?vue&type=template&id=2911a49a&scoped=true&"
import script from "./Kanban.skeleton.vue?vue&type=script&lang=js&"
export * from "./Kanban.skeleton.vue?vue&type=script&lang=js&"
import style0 from "./Kanban.skeleton.vue?vue&type=style&index=0&id=2911a49a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2911a49a",
  null
  
)

export default component.exports